__turbopack_context__.v({
  "adItemCard": "AdItem-module-scss-module__mDp_ZW__adItemCard",
  "large": "AdItem-module-scss-module__mDp_ZW__large",
});
